import { useEffect, useState } from "react";
import { getAssetUrl, revokeAssetUrl } from "../platform/assets/index.js";

/**
 * AssetId를 objectURL로 변환하는 훅 — 결정 #18(lazy objectURL + revoke).
 *
 * 컴포넌트가 화면에 있을 때만 URL을 만들고, 언마운트되거나 assetId가 바뀌면
 * 이전 URL을 revoke한다. 이렇게 해야 가상 스크롤로 카드/이미지가 들고날 때
 * 6s+ 메모리가 새지 않는다.
 */
export function useAssetUrl(assetId: string | undefined): string | undefined {
  const [url, setUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!assetId) {
      setUrl(undefined);
      return;
    }
    let active = true;
    let created: string | undefined;
    void (async () => {
      const u = await getAssetUrl(assetId);
      if (active && u) {
        created = u;
        setUrl(u);
      } else if (u) {
        // 이미 언마운트됨: 만든 URL 즉시 해제.
        revokeAssetUrl(u);
      }
    })();
    return () => {
      active = false;
      revokeAssetUrl(created);
      setUrl(undefined);
    };
  }, [assetId]);

  return url;
}
